import ConnectedPageModel, {
  EnhancedOutgoingMessagesStatistic,
} from '../model/ConnectedPageModel';
import { Pagination } from '../store-interfaces';
import { Plan } from './subscription';
import { FacebookErrorModel } from '../model/FacebookErrorModel';

// Created with FacebookPageLightSerializer in BE
export type BasicPage = ConnectedPageModel & {
  facebookErrors?: boolean;
  disabled?: boolean;
};

// This is different than planType in the BE. PageBillingType gives a more
// accurate category for the type of page.
export enum PageBillingType {
  Free,
  LegacyPro,
  LegacyTeam,
  Team,
  Pro,
  ProUnicorn,
  Promotion,
  SpecialPro,
  SpecialTeam,
  TrialTeam,
  CustomPro,
  CustomTeam,
  Instachamp,
  WP,
  NewTeam,
  TeamLabel,
}

export type EnhancedBillingPage = ConnectedPageModel & {
  messagesStatistic: EnhancedOutgoingMessagesStatistic;
  pageBillingType: PageBillingType;
  plan?: Plan;

  // This field allows EnhancedBillingPage to be created from either BasicPage or ConnectedPageModel
  // The only difference between the two is facebookErrors param is a boolean in BasicPageSerializer in BE
  // while in normal serializer it is FacebookError[].
  //
  // We should address this at some point to simplify interfaces on the FE.
  facebookErrors?: boolean | FacebookErrorModel[];
};

export interface AvailablePageInstagramData {
  id: string;
  username: string;
  name?: string;
  profilePictureUrl?: string;
  followersCount?: number;
}

export interface AvailablePage {
  name: string;
  remoteId: string;
  facebookPageId?: number;
  botId?: number;
  companyId?: number;
  userId?: number;
  instagram?: AvailablePageInstagramData;
  connected_instagram_accounts?: { id: string }[];
  profilePictureUrl?: string;
}

export interface AccessiblePagesByRoles {
  id: number;
  name: string;
  companyId: number;
}

export type AvailablePageWithUniqueName = AvailablePage & {
  uniqueName?: string;
};

export type ConnectedPage = {
  entities: ConnectedPageModel[];
  pagination?: Pagination | null;
  availablePages: {
    data: AvailablePage[];
    next: string | null;
    prev: string | null;
  };
  basicPagesList: BasicPage[];
  busy: boolean;
  hasPermission: boolean;
  pageDetails?: ConnectedPageModel | undefined;
  accessiblePagesByRoles?: AccessiblePagesByRoles[];
};
